<template>
    <v-card class="mx-auto" max-width="344" outlined>
        <v-list-item three-line>
            <v-list-item-content>
                <div class="text-overline mb-4">
                    
                </div>
                <v-list-item-title class="text-h6 mb-1 text-wrap">
                    {{ Option.name.replace('Top Up', '') }}<br/>
                     Top Up {{ Option.displayPrice }}
                </v-list-item-title>
                <!-- <v-list-item-subtitle>{{ Option.description }}
                </v-list-item-subtitle> -->
            </v-list-item-content>

            <v-list-item-avatar tile size="125" color="grey">
                <v-img :src="Option.urlImage"></v-img>
            </v-list-item-avatar>
        </v-list-item>

        <v-card-actions>
            <v-col cols="6">
                <v-text-field class="text-center" :error="Error" type="number" v-model="pax" min="0" max="15"
                    @input="validate">
                    <v-icon slot="append" color="green" @click="add">
                        mdi-plus
                    </v-icon>
                    <v-icon slot="prepend" color="red" @click="minus">
                        mdi-minus
                    </v-icon>

                </v-text-field>



            </v-col>
            <v-col cols="6">
                Number of pax

            </v-col>
        </v-card-actions>
    </v-card>
</template>


<script>
import { mapGetters } from "vuex";
import moment from "moment";


export default {
    props: {
        Option: {
            type: Object,
            required: true
        },
        Error: {
            type: Boolean,
            required: false,
            default: false
        },
        ErrorMessage: {
            type: Array,
            required: false,
            default: ""
        },
        Adult: {
            type: Number,
            required: true,
        },
        Child: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            pax: 0,
        }
    },
    methods: {
        add: function () {
            if (this.pax < 15)
                this.pax++;

            let model = {
                ...this.Option,
                name: this.Option.name,
                amount: this.Option.amount * this.pax,
                //tempDescription: `Top up - ${moment(this.GetArrival()).format('DD-MM-YYYY')} to ${moment(this.GetDeparture()).format('DD-MM-YYYY')} Adult: ${this.Adult} Child: ${this.Child}`,
                tempDescription: '',
                description: `${moment(this.GetArrival()).format('YYYY-MM-DD')}`,
                isMandatory: true,
                addOnType: 'PerQuantity'

            }

            this.$emit('addChargeSelection', model, this.pax, true)
        },
        minus: function () {
            if (this.pax > 0)
                this.pax--;

            let model = {
                ...this.Option,
                name: this.Option.name,
                amount: this.Option.amount * this.pax,
                // tempDescription: `Top up - ${moment(this.GetArrival()).format('DD-MM-YYYY')} to ${moment(this.GetDeparture()).format('DD-MM-YYYY')} Adult: ${this.Adult} Child: ${this.Child}`,
                tempDescription: '',
                description: `${moment(this.GetArrival()).format('YYYY-MM-DD')}`,
                isMandatory: true,
                addOnType: 'PerQuantity'

            }

            this.$emit('addChargeSelection', model, this.pax, true)
        },
        validate() {
            let model = {
                ...this.Option,
                name: this.Option.name,
                //tempDescription: `Top up - ${moment(this.GetArrival()).format('DD-MM-YYYY')} to ${moment(this.GetDeparture()).format('DD-MM-YYYY')} Adult: ${this.Adult} Child: ${this.Child}`,
                tempDescription: '',
                description: `${moment(this.GetArrival()).format('YYYY-MM-DD')}`,
                isMandatory: true

            }
            this.$emit('addChargeSelection', model, this.pax)
        }
    },
    watch: {
        pax: function () {
            this.$emit('numberOfPax', this.pax)
        }
    },
    computed: {
        ...mapGetters([
            'GetArrival',
            'GetDeparture',]),
    }
}

</script>